var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#cecff2",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1920 912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,456) scale(1,1) translate(-960,-456)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur-5nknjkred2c-1",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-5nknjkred2c-2",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-5nknjkred2c-3",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 1616.2865490830834,
    cy: 0,
    transform: "translate(0 533.5968785787976)",
    r: 15.587312178218621,
    fill: "#9400ff",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.67454600164285s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 927.5873121782187;0 -15.587312178218621"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 970.7105388920772,
    cy: 0,
    transform: "translate(0 226.40482273832615)",
    r: 8.770463540828707,
    fill: "#ee00ff",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-8.826240633165735s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 920.7704635408287;0 -8.770463540828707"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 582.5738925089911,
    cy: 0,
    transform: "translate(0 272.032270797269)",
    r: 14.82781941596731,
    fill: "#15ae07",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-6.268156052264292s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 926.8278194159673;0 -14.82781941596731"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1870.7971205748413,
    cy: 0,
    transform: "translate(0 821.2001943159013)",
    r: 13.570610485038046,
    fill: "#9400ff",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-3.486275429731617s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 925.5706104850381;0 -13.570610485038046"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 785.9094702639912,
    cy: 0,
    transform: "translate(0 665.9649511721791)",
    r: 9.23721242039225,
    fill: "#9400ff",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-2.7233692120214137s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 921.2372124203922;0 -9.23721242039225"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1380.5266582919744,
    cy: 0,
    transform: "translate(0 776.6782256796781)",
    r: 6.275739203246766,
    fill: "#ee00ff",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-15.891107236507809s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 918.2757392032468;0 -6.275739203246766"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 996.1671906067045,
    cy: 0,
    transform: "translate(0 670.0842363890749)",
    r: 9.451606428352175,
    fill: "#ee00ff",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.009345404278659s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 921.4516064283522;0 -9.451606428352175"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1696.612434977846,
    cy: 0,
    transform: "translate(0 888.6674914300344)",
    r: 15.677767673502528,
    fill: "#ee00ff",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.025933482732978s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 927.6777676735026;0 -15.677767673502528"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1905.5812748752599,
    cy: 0,
    transform: "translate(0 266.90163045470143)",
    r: 14.877887580520822,
    fill: "#ee00ff",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.390036188959554s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 926.8778875805208;0 -14.877887580520822"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 519.8859519706443,
    cy: 0,
    transform: "translate(0 146.29691376822635)",
    r: 15.850395855553016,
    fill: "#ee00ff",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-3.0696848476411955s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 927.850395855553;0 -15.850395855553016"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 882.4154995126589,
    cy: 0,
    transform: "translate(0 616.4107573548156)",
    r: 7.120810976539412,
    fill: "#9400ff",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-5.207945817727078s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 919.1208109765394;0 -7.120810976539412"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76.48557082629253,
    cy: 0,
    transform: "translate(0 201.02620062849252)",
    r: 13.030914622425222,
    fill: "#ee00ff",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-3.955303195710393s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 925.0309146224253;0 -13.030914622425222"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 668.0552127509127,
    cy: 0,
    transform: "translate(0 772.2102029371299)",
    r: 6.1011622401866745,
    fill: "#15ae07",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-11.497195531801108s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 918.1011622401867;0 -6.1011622401866745"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1750.4944475423551,
    cy: 0,
    transform: "translate(0 877.525805102857)",
    r: 14.452536034295505,
    fill: "#15ae07",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.6570783149200337s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 926.4525360342955;0 -14.452536034295505"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1503.5484466958903,
    cy: 0,
    transform: "translate(0 195.04606521172974)",
    r: 14.895461329383638,
    fill: "#ee00ff",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.2176596192156126s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 926.8954613293837;0 -14.895461329383638"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1285.507972761247,
    cy: 0,
    transform: "translate(0 666.094273049913)",
    r: 11.929069118193022,
    fill: "#15ae07",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.06907523801938265s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 923.9290691181931;0 -11.929069118193022"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.cb724661ed10d520398a06fc5456e567.svg";
export { ForwardRef as ReactComponent };